import script from "./ClinicQuickLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicQuickLinks.vue?vue&type=script&setup=true&lang=js"

import "./ClinicQuickLinks.vue?vue&type=style&index=0&id=2344585e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2344585e"]])

export default __exports__